package com.trevorwiebe.timesheet.payPeriod.data

import com.trevorwiebe.timesheet.core.data.FirestoreListenerRegistry
import com.trevorwiebe.timesheet.core.data.Utils.errorWrapper
import com.trevorwiebe.timesheet.core.domain.CoreRepository
import com.trevorwiebe.timesheet.core.domain.TSResult
import com.trevorwiebe.timesheet.core.domain.dto.TimeSheetDto
import com.trevorwiebe.timesheet.core.domain.model.toTimeSheet
import com.trevorwiebe.timesheet.payPeriod.domain.PayPeriodRepository
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.flow.map

class PayPeriodRepositoryImpl(
    private val firebaseDatabase: Firebase,
    private val coreRepository: CoreRepository
) : PayPeriodRepository {

    override suspend fun getTimeSheets(userId: String?): Flow<TSResult> {
        val organizationIdResult = coreRepository.getOrganizationId()
        if (organizationIdResult.error != null) return flow { emit(organizationIdResult) }
        val organizationId = organizationIdResult.data as String

        val userId = if (userId != null) userId else {
            val userIdResult = coreRepository.getUserId()
            if (userIdResult.error != null) return flow { emit(userIdResult) }
            userIdResult.data as String
        }

        val flow = firebaseDatabase.firestore
            .collection("organizations")
            .document(organizationId)
            .collection("users")
            .document(userId)
            .collection("timeSheets")
            .snapshots
            .map { snapshot ->
                snapshot.documents.map { documentSnapshot ->
                    documentSnapshot.data<TimeSheetDto>().toTimeSheet(documentSnapshot.id)
                }
            }
            .map { TSResult(data = it) }

        return FirestoreListenerRegistry.registerFlow(flow)
    }

    override suspend fun getTimeSheetsOnce(userId: String?, organizationId: String?): TSResult {
        return errorWrapper {
            val organizationId = organizationId ?: run {
                val organizationIdResult = coreRepository.getOrganizationId()
                if (organizationIdResult.error != null) return@errorWrapper organizationIdResult
                organizationIdResult.data as String
            }

            val resolvedUserId = if (userId != null) userId else {
                val userIdResult = coreRepository.getUserId()
                if (userIdResult.error != null) return@errorWrapper userIdResult
                userIdResult.data as String
            }

            val timeSheets = firebaseDatabase.firestore
                .collection("organizations")
                .document(organizationId)
                .collection("users")
                .document(resolvedUserId)
                .collection("timeSheets")
                .get()
                .documents
                .map { document -> document.data<TimeSheetDto>().toTimeSheet(document.id) }

            TSResult(data = timeSheets)
        }
    }

}